/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-08 10:14:38
 * @Explain: 后台接口 - 错误码
 */

export default {
  'API.ERROR.REQ.WAS.ABORTED':
    '[{url}-{reqId}]请求失败，错误类型[{code}]，错误信息[{message}]。请联系开发人员处理。',
  'API.ERROR.CODE.UNKNOWN': '未知错误',
  'API.ERROR.CODE.10114': '内容包含敏感信息',
  // HTTP 状态码
  'API.ERROR.CODE.400': '请求语法错误',
  'API.ERROR.CODE.401': '登录已失效，请重新登录',
  'API.ERROR.CODE.403': '无法执行此请求',
  'API.ERROR.CODE.404': '接口请求失败',
  'API.ERROR.CODE.405': '请求方式有误',
  'API.ERROR.CODE.500': '服务器居然开小差了，请稍后再试吧',
  'API.ERROR.CODE.502': '服务繁忙，请稍后再试',
  'API.ERROR.CODE.504': '请求超时，请稍后再试',

  'API.ERROR.CODE.1001': '操作无权限！',
  'API.ERROR.CODE.1003': '签名失效',

  'API.ERROR.CODE.2000': '当前输入的活动名称已存在',
  'API.ERROR.CODE.2001': '审批失败', // '当前审核活动已撤销',
  'API.ERROR.CODE.2002': '未设置默认语言',
  'API.ERROR.CODE.2003': '活动审批成功,获取申请人配置邮箱失败，请前去配置',
  'API.ERROR.CODE.2004': '活动审批成功，邮件发送失败',
  'API.ERROR.CODE.2008': '两次催办时间需间隔30分钟',
  'API.ERROR.CODE.2013': '开始时间不可修改',
  'API.ERROR.CODE.2014': '指定的开始和结束日期不包含设置的{day}号',
  'API.ERROR.CODE.2015': '指定的开始和结束日期不包含设置的{day}',
  'API.ERROR.CODE.2016': '活动已开始，撤销失败',

  'API.ERROR.CODE.3000': '操作无权限',
  'API.ERROR.CODE.3001': '您已在项目内，如需修改权限，请联系项目创建人处理。',

  // 分层
  'API.ERROR.CODE.4001': '分层被活动引用，故无法删除',
  'API.ERROR.CODE.4002': '名称重复',

  // 标签
  'API.ERROR.CODE.5001': '标签被活动引用，故无法删除',
  'API.ERROR.CODE.10360': '不能输入",", "|" 或  ";"',

  // 联系人
  'API.ERROR.CODE.6001': '创建的规则已存在',
  'API.ERROR.CODE.16001': '操作无权限',

  // 字段
  'API.ERROR.CODE.7001': '名称重复',
  'API.ERROR.CODE.7002': '请联系管理员',

  // 我的项目
  'API.ERROR.CODE.8000': '您已申请过当前项目，请勿重复申请',

  // 域名
  'API.ERROR.CODE.10004': '请检查发件人信息', // 发送测试邮件 - '域名不存在',

  'API.ERROR.CODE.10054': '邮箱地址输入有误，请检查后重试',
  'API.ERROR.CODE.10057': '用户不存在',
  'API.ERROR.CODE.10081': '申请人{name}未收到提醒邮件，可线下通知',
  'API.ERROR.CODE.10108': '文件夹名称不能重复',
  'API.ERROR.CODE.10110': '名称不可重复',
  'API.ERROR.CODE.10151': '文件中包含无效邮箱地址，请检查后重新上传',
  'API.ERROR.CODE.10166': '当前状态不可编辑',
  'API.ERROR.CODE.10175': '发件人名称不能重复',
  'API.ERROR.CODE.10177': '暂无查询到对应的用户',
  'API.ERROR.CODE.10178': '发件地址不能重复',
  'API.ERROR.CODE.10184': '文件中地点格式填写错误，请检查后重新上传',
  'API.ERROR.CODE.10185': '不可上传包含相同邮箱地址的文件',
  'API.ERROR.CODE.10191': '文件中包含邮箱地址为空，请检查后重新上传',
  'API.ERROR.CODE.10192': '文件中语言填写有误，请检查后重新上传',
  'API.ERROR.CODE.10199': '数据为空',

  'API.ERROR.CODE.10314': '邀请的email已经存在',
  'API.ERROR.CODE.10315': '发件地址不存在，请重新选择',
  'API.ERROR.CODE.10351': '项目不存在',
  'API.ERROR.CODE.10354': '最多1000个标签',
  'API.ERROR.CODE.10355': '标签名已存在',
  'API.ERROR.CODE.10356': '通过API上传联系人需要使用此Tag，故无法删除',
  'API.ERROR.CODE.10357': '字段名称与已有字段名称重复',

  'API.ERROR.CODE.10500': '验证邮箱格式有误，请重新输入',
  'API.ERROR.CODE.10501': '输入的验证邮箱中变量格式有误，请重新输入',
  'API.ERROR.CODE.10502': '输入的验证邮箱中变量包含空值，请检查后重新输入',
  'API.ERROR.CODE.10503': '输入的验证邮箱中变量Key值存在重复，请检查后重新输入',
  'API.ERROR.CODE.10504': '邮箱已存在',
  'API.ERROR.CODE.10508': '已经邀请过该用户',
  'API.ERROR.CODE.10509': '该邀请已过期',
  'API.ERROR.CODE.10512': '自己不能邀请自己',
  'API.ERROR.CODE.10513': '活动正在运行，不能删除变量',

  // 偏好
  'API.ERROR.CODE.10517': '选项名称重复',

  // 占位符
  'API.ERROR.CODE.10520': '邮箱域名无效',
  'API.ERROR.CODE.10521': '占位符名称已存在',
  'API.ERROR.CODE.10524': '当前业务正在解析文件，请稍后重试',
  'API.ERROR.CODE.10525':
    '请输入正确的资源码名称，支持英文字母、数字、短横线、下划线，且严格区分大小写',

  // api-key
  'API.ERROR.CODE.10601': '名称已存在',
  'API.ERROR.CODE.10602': '最多50个API key',
  'API.ERROR.CODE.10603': '名称已上限',
  'API.ERROR.CODE.10604': '备注已上限',
  'API.ERROR.CODE.10605': 'key id 异常',
  'API.ERROR.CODE.10606': '密钥已存在',
  'API.ERROR.CODE.10608': 'key已撤销',

  // cos文件失效了
  'API.ERROR.CODE.10705': '下载文件已失效',

  // webhook
  'API.ERROR.CODE.10307': 'URL地址超出1000个字符，请删减后重试',
  'API.ERROR.CODE.10800': '无效链接，请重新输入',
  'API.ERROR.CODE.10801': '发送测试失败',
  'API.ERROR.CODE.10806': 'URL地址已存在',

  // 自动化活动
  'API.ERROR.CODE.12001': '旅程名称重复，请修改',
  'API.ERROR.CODE.12002': '选择的联系人来源被引用，请检查后重试',

  'API.ERROR.CODE.13001': '没有足够的区域可用',

  'API.ERROR.CODE.20001': '角色被其他人申请',
  'API.ERROR.CODE.20002': '角色已经申请',
  'API.ERROR.CODE.20003': '审批人无申请权限',
  'API.ERROR.CODE.20004': '角色不能被删除',
  'API.ERROR.CODE.20005': '数据不存在',
  'API.ERROR.CODE.20006': '不能删除其他用户的角色',
  'API.ERROR.CODE.20007': '调用Pnt接口失败',
  'API.ERROR.CODE.20008': 'Pnt未审批通过，不能审批',
  'API.ERROR.CODE.20009': '项目角色不支持按code申请',
  'API.ERROR.CODE.20010': '游戏不存在',
  'API.ERROR.CODE.20011': '新增用户失败',
  'API.ERROR.CODE.20012': '用户申请的Owner角色超出限制',
  'API.ERROR.CODE.20013': '获取用户emails错误',
  'API.ERROR.CODE.20014': '用户不在白名单中，不能登录使用系统',
  'API.ERROR.CODE.20015': '操作无权限',
  'API.ERROR.CODE.20016': 'demo项目不开放',
  'API.ERROR.CODE.20017': 'Pnt已拒绝，不能审批通过',
  'API.ERROR.CODE.20018': '暂不支持重新申请',

  'API.ERROR.CODE.21003': '请输入表单名称',
  'API.ERROR.CODE.21004': '表单名称重复',
  'API.ERROR.CODE.21011': '校验失败',
  'API.ERROR.CODE.21012': '数字码格式有误',
  'API.ERROR.CODE.21013': '数字码校验失败',
  'API.ERROR.CODE.21014': '数字码校验失败',
  'API.ERROR.CODE.21016': '备份验证码验证失败',
  'API.ERROR.CODE.21020': '模板被引用，不可编辑',
  'API.ERROR.CODE.21022': '测试业务不允许创建超过249个联系人的活动',
  'API.ERROR.CODE.21024': '默认配置未配置，请检查',
  'API.ERROR.CODE.21025': '默认配置发件人信息被删除，请检查',
  'API.ERROR.CODE.24002': '注册表单不存在',
  'API.ERROR.CODE.24003': '表单未激活',

  // 登录、注册、忘记密码
  'API.ERROR.CODE.10002': '验证码发送失败，请稍后重试',
  'API.ERROR.CODE.10003': '参数有误',
  'API.ERROR.CODE.10005': '验证码发送失败，请稍后重试',
  'API.ERROR.CODE.10006': '域名未验证',
  'API.ERROR.CODE.10007': '域名未填写',
  'API.ERROR.CODE.10011': '验证码已过期',
  'API.ERROR.CODE.10012': '验证码错误',
  'API.ERROR.CODE.10014': '账号或密码错误，请确认后登录',
  'API.ERROR.CODE.10015': '账号或密码错误，请确认后登录',
  'API.ERROR.CODE.10017': '邮箱或用户名已注册', // 邮箱地址已存在
  'API.ERROR.CODE.10018': '邮箱或用户名已注册', // 用户名已存在
  'API.ERROR.CODE.10023': '验证码已过期', // google验证码
  'API.ERROR.CODE.10028': '新修改密码与旧密码重复',

  // 模板、占位符被活动
  'API.ERROR.CODE.10115': '线上活动引用中，不允许变更',
  'API.ERROR.CODE.10528': '线上活动引用中，不允许变更',
  // 活动进行中禁止修改
  'API.ERROR.CODE.2010': '活动进行中，不允许修改',
  'API.ERROR.CODE.10607': 'API key 被用户旅程引用',
  'API.ERROR.CODE.24001': '表单被用户旅程引用',
  'API.ERROR.CODE.15001': '线上活动引用中，不允许变更',

  // 被其它信息引用导致列表不可操作项补课操作提示文案
  'API.ERROR.CODE.00001': '{who}引用中，不可{doText}',
  'API.ERROR.CODE.00003': '活动进行中{name}不允许修改',
  'API.ERROR.CODE.00002': '表单引用中，不可删除',
  'API.ERROR.CODE.00004': '表单引用中，不可重命名',
  'API.ERROR.CODE.00005': '旅程使用中，无法修改',
  'API.ERROR.CODE.00006': '邮件模板引用中，不允许变更',
  'API.ERROR.CODE.00007': '活动引用中，不允许变更', // 内置表单被活动引用（常规、周期、AB、用户旅程）草稿状态，表单不允许删除的提示文案

  // nest-WhatsApp接口报错文案
  'API.ERROR.CODE.NEST.401': '请先登录',

  'API.ERROR.CODE.NEST.1000': '参数错误',
  'API.ERROR.CODE.NEST.1001': '数据验证错误',
  'API.ERROR.CODE.NEST.1002': '数据不存在',
  'API.ERROR.CODE.NEST.1003': '数据已存在',
  'API.ERROR.CODE.NEST.1004': '操作不允许',
  'API.ERROR.CODE.NEST.1005': '权限不足',

  'API.ERROR.CODE.NEST.2000': '文件不存在',
  'API.ERROR.CODE.NEST.2001': '文件读取失败',
  'API.ERROR.CODE.NEST.2002': '文件解析失败',

  'API.ERROR.CODE.NEST.3000': '任务不存在',
  'API.ERROR.CODE.NEST.3001': '任务状态无效',
  'API.ERROR.CODE.NEST.3002': '任务创建失败',
  'API.ERROR.CODE.NEST.3003': '任务执行失败',

  'API.ERROR.CODE.NEST.4000': '超过速率限制',
  'API.ERROR.CODE.NEST.4001': '速率限制配置错误',

  'API.ERROR.CODE.NEST.5000': '第三方服务错误',
  'API.ERROR.CODE.NEST.5001': 'HTTP请求失败',
  'API.ERROR.CODE.NEST.5002': 'API调用失败',

  'API.ERROR.CODE.NEST.6000': 'WhatsApp服务错误',
  'API.ERROR.CODE.NEST.6001': 'WhatsApp消息发送失败',
  'API.ERROR.CODE.NEST.6002': 'WhatsApp Webhook错误',
  'API.ERROR.CODE.NEST.6003': 'WhatsApp跟踪数据不存在',
  'API.ERROR.CODE.NEST.6004': 'WhatsApp跟踪参数缺失',

  'API.ERROR.CODE.NEST.7000': '活动名称已存在',
  'API.ERROR.CODE.NEST.7001': '活动不存在或无权限访问',
  'API.ERROR.CODE.NEST.7002': '活动不是草稿状态，无法修改',
  'API.ERROR.CODE.NEST.7003': '缺少任务参数列表',
  'API.ERROR.CODE.NEST.7004': '任务参数列表格式错误',
  'API.ERROR.CODE.NEST.7005': '创建任务失败',
  'API.ERROR.CODE.NEST.7006': '发送方手机号无效',
  'API.ERROR.CODE.NEST.7007': '活动不是进行中状态，无法终止',
  'API.ERROR.CODE.NEST.7008': '活动不是暂停状态，无法恢复',
  'API.ERROR.CODE.NEST.7009': '发送时间必须大于当前时间',

  'API.ERROR.CODE.NEST.8000': 'Game不存在',
  'API.ERROR.CODE.NEST.8001': 'Game没有关联的WhatsApp账户',

  'API.ERROR.CODE.NEST.10000': '获取模板失败',

  'API.ERROR.CODE.NEST.ERROR': '请求失败',
  'API.ERROR.CODE.19002': '测试玩家同步中，请稍后再试',
};
